// query param keys
export const INFO_LAYER_CONTENT_QUERY_KEY = 'info';

export const GLOBAL_QUERY_PARAMS = {
  isWebView: 'app_webview',
};
